import axios from "axios";
import Footer from "../components/footer";
import Header from "../components/header";
import PageHeader from "../components/pageHeader";
import SideNav from "../components/sidenav";
import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";


const UploadArtwork = ()=>{
    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const { id } = useParams();
    const [selectedImage, setSelectedImage] = useState(null);
    const [productData, setProductData] = useState([]);
    const [imageData, setImageData] = useState([]);
    const [productDetails, setProductDetails] = useState({
        productTitle: '', ownerName: '', artistName: '', category: ''
    });
    // Function to fetch data from API
    const fetchData = async (url, setData) => {
        
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(`https://igapi.heuristticminds.com/api/ProductList/Get-GetArtworkDetailsToViewByProductID?id=${id}`, setProductDetails);
            fetchData('https://igapi.heuristticminds.com/api/ProductList/Get-GetArtworkImagesByProductID?id=' + id, setImageData);
        }
    }, [id]);

    const columns = [
        {
            cell: (row) => (
                <div>
                    <img
                        src={`../images/products/thumbnail/${row.image}` }
                        style={{ width: "100px", height: "100px" }}
                    />
                </div>
            )
        },
        {
            name: "Image Name",
            selector: row => row.image,
            sortable: true,
            width: "430px"
        },
        {
            name: "Default Image",
            cell: (row) => (
                <div>
                    <Link to={``} onClick={() => onDefaultClick(row.id, row.product_id)}>
                        <img
                            src={row.defaultImage === 1 ? "/images/ImgActive.gif" : "/images/ImgInActive.gif"}
                            alt="Change Default"
                            title="Change Default"
                            style={{ width: "50px", height: "25px" }}
                        />
                    </Link>
                </div>
            ),
        },
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <Link to={''} onClick={() => onDeleteClick(row.id, row.defaultImage)}>
                        <img
                            src="/images/ImgDel.png"
                            alt="Delete"
                            style={{ width: "25px", height: "25px" }}
                        />
                    </Link>
                </div>
            ),
        },
    ];

    const onDefaultClick = async (id, productID) => {
        const confirmed = window.confirm("Are you sure you want to change default/primary image?");
        if (!confirmed) return;

        try {
            const encodedid = encodeURIComponent(id);
            const encodedProductID = encodeURIComponent(productID);

            const response = await axios.put(`https://igapi.heuristticminds.com/api/ProductList/Update-ChangeProductDefaultImage?id=${encodedid}&ProductID=${encodedProductID}`);

            if (response.status === 200) {
                refreshImageData();
            } else {
                console.error('Change failed');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const onDeleteClick = async (id, defaultImage) => {
        if (defaultImage === 1) {
            alert("This is the default image and cannot be deleted.");
            return;
        }

        const confirmed = window.confirm("Deleting this record will change the default image. Are you sure you want to delete it?");
        if (!confirmed) return;

        try {
            await axios.delete(`https://igapi.heuristticminds.com/api/ProductList/Delete-DeleteProductImage?id=${id}`);
            refreshImageData();
        } catch (error) {
            console.error('Error deleting image:', error);
        }
    };

    const refreshImageData = async () => {
        try {
            if (id) {
                const response = await axios.get('https://igapi.heuristticminds.com/api/ProductList/Get-GetArtworkImagesByProductID?id=' + id);
                setImageData(response.data);
            }
        } catch (error) {
            console.error('Error refreshing image data:', error);
        }
    };

    const handleImageChange = (e) => {
        setSelectedImage(Array.from(e.target.files));
    };

    const handleUpload = async () => {
        const formData = new FormData();
        for (let i = 0; i < selectedImage.length; i++) {
            formData.append('images', selectedImage[i]);
        }

        try {
            
            const uploadResponse = await axios.post('http://localhost:3000/uploadImage/uploadProductImages', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            
            const uploadedImageNames = uploadResponse.data.fileUrls;
            const saveOperations = uploadedImageNames.map((fileName) => {
                const imageDetails = {
                    image: fileName,
                    product_id: id,
                    createdBy: userInfo.user_id
                };
                return axios.post('https://igapi.heuristticminds.com/api/ProductList/Add-SaveProductImages', imageDetails);
            });

            await Promise.all(saveOperations);
            console.log('All images saved successfully');
            refreshImageData();
        } catch (error) {
            console.error('Error uploading files:', error);
        }
    };

    return (
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <PageHeader name='Upload Artwork' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4">
                                    <div className="card-header">Add Artwork Images</div>
                                    <div className="card-body">
                                        <NavLink className="btn btn-primary float-end" to={'/artworkAll'}>
                                            <i className="bi bi-arrow-return-left"></i> Back
                                        </NavLink>
                                        <div className="clearfix"></div>
                                        <div className="p-4 pt-2">
                                            <div className="row">
                                                <div className="col-sm-3 form-group mb-3">
                                                    <label>Artwork ID:</label>
                                                    <div>IG{productDetails.id}</div>
                                                </div>
                                                <div className="col-sm-3 form-group mb-3">
                                                    <label>Artwork Title:</label>
                                                    <div>{productDetails.productTitle}</div>
                                                </div>
                                                
                                                <div className="col-sm-2 form-group mb-3">
                                                    <label>Artwork Type:</label>
                                                    <div>{productDetails.category}</div>
                                                </div>
                                               
                                                <div className="col-sm-2 form-group mb-3">
                                                    <label>Price:</label>
                                                    <div>{productDetails.price}</div>
                                                </div>
                                                <div className="col-sm-2 form-group mb-3">
                                                    <label>Owner:</label>
                                                    <div>{productDetails.ownerName}</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4 form-group mb-3">
                                                    <label htmlFor="imageUpload">Select All Images of Product:<span style={{ color: "#ff0000" }}>*</span></label>
                                                    <input type="file" name="images" multiple onChange={handleImageChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6 form-group mb-6">
                                                <button type="button" className="btn btn-primary float-end" onClick={handleUpload} disabled={!selectedImage || selectedImage.length === 0}>Upload</button>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="pb-2">
                                                <div className="ps-2 pe-2">
                                                     <DataTable columns={columns} data={imageData} /> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );
}
export default UploadArtwork;
